import { FC } from 'react'

import { Badge } from '@/enums'

import { Crown, ICrownProps } from '../assets/Crown'
import { Avatar } from '.'

type AvatarWithCrownProps = {
  place: ICrownProps['place']
  size?: 'small' | 'medium' | 'large' | 'xl' | 'xxl'
  className?: string
  userId?: string
  stroke?: string
  lazy?: boolean
  clickable?: boolean
  badge?: Badge
  isModerator?: boolean
  isAmbassador?: boolean
  username?: string
}

export const AvatarWithCrown: FC<AvatarWithCrownProps> = ({
  place,
  ...avatarProps
}) => {
  return (
    <div className="relative">
      <span className="absolute left-full bottom-full -translate-x-1/2 translate-y-1/2 rotate-[4deg] w-9 h-9">
        <Crown place={place} className="w-full h-full" />
      </span>
      <Avatar {...avatarProps} />
    </div>
  )
}
